import { colors } from '../../Colors/colors'

export const dataCoPilot = {
   light: {
      common: {
         defaultTextColor: 'text-gray-900',
         defaultBorderColor: 'border-gray-300',
         baseBgColor: 'bg-base-white',
         defaultIconColor: colors['gray-500'],
         headingTextColor: 'text-gray-900',
         lineSeparatorBgColor: 'bg-gray-300',
         responseLoadingColor: colors['base-black'],
         responseActionIconFillColor: colors['primary-600'],
         skeletonLoaderCardBorderColor: 'border-gray-200',
         errorTextColor: 'text-gray-600',
         toolTipBgColor: 'bg-gray-900'
      },
      sqlCard: {
         headerTextColor: 'text-gray-600',
         queryTextColor: 'text-primary-600',
         queryExplanationTextColor: 'text-base-black',
         explanationTextColor: 'text-gray-800',
         queryBgColor: 'bg-gray-50'
      },
      coPilotResponse: {
         textColor: 'text-gray-600'
      }
   },
   dark: {}
}
